module.exports = __webpack_public_path__ + "img/gebrateneshuehnerfleischmithintergrundseitlich.c993c639.jpg";